import React from "react";
import "./ImagingMainSection.css";
import { useNavigate } from "react-router-dom";

const ImagingMainSection = () => {
  const navigate = useNavigate();
  const servicesDummy = [
    {
      title: "CT SCAN",
      dept: "CT-SCAN",
      description:
        "A CT scan produces quick, detailed cross-sectional images of the body, helping detect injuries, infections, and internal abnormalities...",
    },
    {
      title: "MRI",
      dept: "MRI",
      description:
        "MRI scans provide detailed, high-resolution images of internal organs and tissues, helping diagnose neurological and musculoskeletal conditions effectively...",
    },
    {
      title: "ULTRASOUND",
      dept: "USG",
      description:
        "Ultrasound uses safe, non-invasive sound waves to capture real-time images of organs, soft tissues, and pregnancy-related developments...",
    },
    {
      title: "X-RAY",
      dept: "X-RAY",
      description:
        "X-ray imaging offers a fast, non-invasive way to examine bones and internal structures, commonly used for injuries and routine screenings...",
    },
    {
      title: "CARDIOLOGY",
      dept: "CARDIOLOGY",
      description:
        "Cardiology helps identify and manage conditions affecting the heart and blood vessels through advanced screening and diagnostic procedures...",
    },
    {
      title: "GASTROENTEROLOGY",
      dept: "Gastrology",
      description:
        "Gastroenterology focuses on diagnosing and treating stomach, intestine, liver, and pancreas disorders to ensure proper digestive health...",
    },

    {
      title: "NEUROLOGY",
      dept: "NEUROLOGY",
      description:
        "Neurology focuses on diagnosing and treating disorders of the brain, spine, and nerves, ensuring comprehensive neurological evaluation...",
    },
    {
      title: "PULMONOLOGY",
      dept:'Pulmonology',
      description:
        "Pulmonology specializes in assessing and treating asthma, COPD, chronic cough, sleep apnea, and other lung-related respiratory conditions...",
    },
    {
      title: "NEPHROLOGY",
      dept: "Nephrology",
      description:
        "Nephrology manages kidney-related disorders, including chronic disease, hypertension, electrolyte issues, and long-term renal health care...",
    },
    {
      title: "UROLOGY",
      dept: "Urology",
      description:
        "Urology focuses on the diagnosis and treatment of diseases related to the urinary tract and the male reproductive system...",
    }
  ];




  return (
    <div className="service-section">
     { /*<h2 className="service-title">Our Services</h2>*/}

      <div className="grid-container">
        {servicesDummy.map((item, index) => (
          <div className="service-card" key={index}>
            <h3 className="service-card-title">{item.title}</h3>
            <p className="service-card-desc">{item.description}</p>

            <button
              className="know-more-btn"
              onClick={() => navigate(`/service/imaging/${item.dept}`)}
            >
              Know more &gt;
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImagingMainSection;
